
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Instantly authenticate bank account details for use with Checkout.com's Unified Payments API, and unlock unrivaled payment performance "
};
export const partnerProps = {
  partner: 'Checkout.com',
  clientLibrary: 'checkout',
  subtitle: metadata.description,
  registrationUrl: 'mailto:partnerships@checkout.com?subject=New Plaid Checkout.com Account',
  apiUrl: 'https://docs.checkout.com/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Checkout.com have partnered to offer a more secure and frictionless ACH payments experience.  Plaid enables the authentication of external bank accounts and returns account data that is exchanged securely to Checkout.com prior to payment initiation - businesses no longer need to hold any sensitive customer account information.`}</p>
    <p>{`Companies can then easily process ACH payments using Checkout.com's unified payments API. Businesses choose Checkout.com to power connected payments with its high authorization rates, global coverage, and modular microservices model. Checkout.com makes it easy for businesses to access a full suite of payment offerings, through one seamless solution. `}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
